import { render, staticRenderFns } from "./PromoteSection.vue?vue&type=template&id=01f64490"
import script from "./PromoteSection.vue?vue&type=script&lang=js"
export * from "./PromoteSection.vue?vue&type=script&lang=js"
import style0 from "./PromoteSection.vue?vue&type=style&index=0&id=01f64490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports